import React, { useState } from "react";
import Modal from "./Modal.tsx";
import InputField from "../Forms/InputField.js";
import { createMedication } from "../../services/medication.js";
import toast from "react-hot-toast";

export const CreateMedication = ({ isOpen, onClose, reload }) => {
  const [medication, setMedication] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await createMedication({ name: medication });
      reload();
      onClose(false);
      toast.success("Medication created successfully");
    } catch (error) {
      console.log(error);
      toast.error("Failed to create medication");
    }
    setIsLoading(false);
  };
  return (
    <Modal
      title="Create Medication"
      size="md"
      onCancel={() => onClose(false)}
      isOpen={isOpen}
    >
      <form onSubmit={onSubmit}>
        <InputField
          name="medication"
          label="Medication"
          value={medication}
          required
          onChange={(e) => setMedication(e.target.value)}
        />
        <button
          type="submit"
          className="btn btn__primary btn--block"
          disabled={isLoading}
        >
          {isLoading ? "Loading" : "Submit"}
        </button>
      </form>
    </Modal>
  );
};
